import qs from 'qs';
import { createSnack } from 'snackbar/snackbarSlice';
import http from 'utils/http';

const fetchCSVReport = (urlPrefix, params) => dispatch => {
  const paramString = qs.stringify(params, {
    allowDots: true,
    encode: false,
  });

  return http.get(`/${urlPrefix}/export?${paramString}`).catch(error => {
    dispatch(
      createSnack({
        message: error.response.data.title,
        options: { variant: 'error' },
      })
    );
  });
};

export default fetchCSVReport;
